export default "__VITE_ASSET__D3lTTo7i__"